import mergeRefs from 'merge-refs';
import { forwardRef, useRef } from 'react';
import cn from '@/utils/merge-class-names';

interface Props {
  checked?: boolean;
  className?: string;
  name?: string;
  isLoading?: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

const Toggle = forwardRef<HTMLInputElement, Props>(function Toggle(
  { checked = false, className, isLoading = false, name, onChange, disabled = false },
  ref,
) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <input
      ref={mergeRefs(ref, inputRef)}
      type='checkbox'
      name={name}
      className={cn('toggle toggle-sm border-none bg-neutral-0', className)}
      style={{ '--tglbg': checked ? 'hsl(var(--p))' : 'hsl(var(--b3))' } as React.CSSProperties}
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
    />
  );
});

export default Toggle;
